import {
  getFieldSettings,
  patchFieldSettings,
  removeInheritedFieldSettings,
} from "../../../../../../../utils/fieldSettings";
import { isPreviewGroupLabelRecord } from "./previewFieldLabel";

const upsertPreviewGroupRecord = (fields, group, patch) => {
  const groupId = group?.field_id;
  const groupType = group?.field_type ?? group?.type;
  if (!groupId || !["checkboxGroup", "selectGroup"].includes(groupType))
    return fields;
  if (
    group.field_instance_id &&
    !fields.some(
      (field) =>
        field?.field_id === groupId &&
        field.field_instance_id === group.field_instance_id,
    )
  )
    return fields;
  const existing = fields.find(
    (field) =>
      field?.field_id === groupId &&
      isPreviewGroupLabelRecord(field, groupType),
  );
  if (existing) {
    return fields.map((field) =>
      field === existing ? { ...field, ...patch } : field,
    );
  }
  const optionIds = new Set(
    (group.options || [])
      .map((option) => option?.field_id ?? option?.value)
      .filter(Boolean),
  );
  const linked = fields.filter(
    (field) =>
      !isPreviewGroupLabelRecord(field, groupType) &&
      (field?.field_id === groupId ||
        optionIds.has(field?.field_id) ||
        field?.parent_field_id === groupId),
  );
  if (!linked.length) return fields;
  const first = linked[0];
  const usedNames = new Set(fields.map((field) => field?.name));
  let name = String(groupId);
  let suffix = 1;
  while (usedNames.has(name)) name = `${groupId}__group_${suffix++}`;
  const orders = linked
    .map((field) => field?.order)
    .filter(
      (value) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        Number.isFinite(Number(value)),
    )
    .map(Number);
  const page = first.page ?? first.page_num ?? 1;
  return [
    ...fields,
    {
      name,
      field_id: groupId,
      field_type: groupType,
      field_label: "",
      label: "",
      type: "PDFTextField",
      hidden: true,
      form_id: first.form_id,
      block_id: group.block_id ?? first.block_id ?? first.section,
      block_label: group.block_label ?? first.block_label ?? first.section,
      ...(orders.length
        ? { order: Math.min(...orders) }
        : group.order != null
          ? { order: group.order }
          : {}),
      page,
      page_num: page,
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      rect: { X: 0, Y: 0, W: 0, H: 0 },
      fontSize: 10,
      fontSizes: [],
      autoFontSize: true,
      ...patch,
    },
  ];
};

export const updatePreviewGroupSettings = (
  fields = [],
  group,
  patch = {},
  sharedField,
) => {
  const existing = fields.find(
    (field) =>
      field?.field_id === group?.field_id &&
      isPreviewGroupLabelRecord(field, group?.field_type ?? group?.type),
  );
  const settings = getFieldSettings(
    removeInheritedFieldSettings(
      patchFieldSettings(existing, patch),
      sharedField,
    ),
  );
  if (!existing && !Object.keys(settings).length) return fields;
  if (
    existing &&
    !Object.keys(settings).length &&
    !String(existing.field_label ?? existing.label ?? "").trim()
  ) {
    return fields.filter((field) => field !== existing);
  }
  return upsertPreviewGroupRecord(fields, group, { field_settings: settings });
};
